import React from 'react'
import Constants from 'src/helper/Constants';
import System from 'src/helper/system';

const OrderDetailViewAllTrackingPopup = (props) => {
    const { SetStatus, data } = props;
    const { translation: t } = System;

    const displayTrackingNumber = (number) => {
        let carrierLink = ''

        if (data?.carrier && System.getCurrentRegionWithType(Constants.speedBoats.japanAbbr)) {
            const carrierMethod = data?.carrier?.split('|')[1] || ''
            carrierLink = carrierMethod !== '' ? System.getTrackingLink(carrierMethod) : ''
        }

        return carrierLink !== '' ? <a href={carrierLink} target='_blank'><span className='text-blue'>{number}</span></a> :
            <span className='text-black'>{number}</span>
    }

    return (
        <>
            <div className="avnet-modal modal-700">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal" onClick={(() => SetStatus(false))}>×</button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">{t('viewAllTrackingWayBillNo')}</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body py-0">
                        <div className="clearfix" />

                        <div className='mb-3 text-center mt-4 mb-5'>
                            <div><p className='text-black'>{t('trackingWayBillNoForPONo')} {data.poNumber}</p></div>
                        </div>

                        <div className='m-b-30'>
                            <div className="bs5 row text-center">
                                {
                                    data.trackingDetails && data.trackingDetails.length > 0 &&
                                    data.trackingDetails?.filter((item, index, self) => self.indexOf(item) === index && item !== "")?.map((v, i) => (
                                        <div className='col-md-3 mb-1' key={i}>
                                            {displayTrackingNumber(v)}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal" onClick={(() => SetStatus(false))}>
                                {t('close')}
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OrderDetailViewAllTrackingPopup